__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/9fcd779d28a5e12fd1a103bc3353803383dbc4b835f6b6502ef7f9bf/";